import {
    IContactLens,
    IContactLensAttributes,
    IContactLensForm,
    IMySavedPrescriptionItem,
    IMySavedPrescriptionsList,
} from '@interfaces/contactsInterfaces';

////////// MY SAVED PRESCRIPTIONS //////////

/** The functions below returns the most recent mapped saved prescriptions */

export const mapSavedPrescriptionsList = (data: any): IMySavedPrescriptionsList => {
    return data.map(element => {
        return {
            ...mapSavedPrescription(element),
        };
    });
};

export const mapSavedPrescription = (data: any): IMySavedPrescriptionItem => {
    return {
        prescriptionName: data.prescriptionName,
        prescriptionId: data.prescriptionId,
        prescriptionType: data.prescriptionType,
        hasRelatedOrderPrescriptions: data.hasRelatedOrderPrescriptions,
        firstName: data.firstName,
        lastName: data.lastName,
        productCategory: data.productCategory,
        prescriptionValue: {
            rightSphere: data.rightSphere,
            leftSphere: data.leftSphere,
            leftCyl: data.leftCyl,
            rightCyl: data.rightCyl,
            rightAxis: data.rightAxis,
            leftAxis: data.leftAxis,
            rightAdd: data.rightAdd,
            leftAdd: data.leftAdd,
            rightDominance: data.rightDominance,
            leftDominance: data.leftDominance,
            pupillaryDistance: data.pupillaryDistance,
            pdRight: data.rpDistance,
            pdLeft: data.lpDistance,
        },
        prism: {
            prismEnable: data.prismEnable === 'true',
            odVPrism: data.odVPrism,
            osVPrism: data.osVPrism,
            odHPrism: data.odHPrism,
            osHPrism: data.osHPrism,
            odVPrismBaseDir: data.odVPrismBaseDir,
            osVPrismBaseDir: data.osVPrismBaseDir,
            odHPrismBaseDir: data.odHPrismBaseDir,
            osHPrismBaseDir: data.osHPrismBaseDir,
        },
        lastUpdate: data.lastUpdate,
        lastCreate: data.lastCreate,
        leftCatentryId: +data.leftCatentryId,
        rightCatentryId: +data.rightCatentryId,
        leftCatentryParentId: +data.leftCatentryParentId,
        rightCatentryParentId: +data.rightCatentryParentId,
        doctor: {
            name: data.doctor,
            clinic: data.clinic,
            phone: data.doctorFax,
            address: data.doctorAddress,
        },
        submissionMethod: data.prescriptionOriginMode,
        fileName: data.fileName,
    };
};

export const mapClAttributes = (attributes): IContactLensAttributes => {
    return {
        power: attributes?.CL_SPHERE_POWER,
        baseCurve: attributes?.CL_BASE_CURVE,
        cylinder: attributes?.CL_CYLINDER,
        axis: attributes?.CL_AXIS,
        diameter: attributes?.CL_DIAMETER,
        add: attributes?.CL_ADDITION,
        color: attributes?.CL_COLOR,
        dominance: attributes?.CL_DOMINANCE.map(val => {
            return val === 'True' ? 'D' : 'N';
        }),
    };
};

export const mapClData = (response): IContactLens => {
    const parentId = +response?.catalogEntry?.catalogEntryIdentifier?.parentProductId;

    return {
        productId: +response?.catalogEntry?.catalogEntryIdentifier.uniqueId,
        name: response?.catalogEntry?.description[0].name,
        model: response?.catalogEntry?.description[0].model,
        brand: response?.catalogEntry?.description[0].brand,
        thumbnail: response?.catalogEntry?.description[0].thumbnail.replace(
            '?imwidth=',
            '?imwidth=80'
        ),
        attributes: mapClAttributes(response?.attributes || response?.catalogEntry?.attributes),
        ...(!!parentId && { parentId: parentId }),
    };
};

export const getInitialValue = (values: any[]) => {
    return values?.length === 1 ? values[0] : '';
};

// remove unused fields and values before submitting the form
export const cleanContactLensForm = (data: IContactLensForm): IContactLensForm => {
    let payload = { ...data } as IContactLensForm;

    // remove left eye data if not selected
    if (!payload.rxLeftEye) {
        const entries = Object.entries(payload).filter(
            ([k, _]): boolean => !k.toLowerCase().includes('left')
        );
        payload = Object.fromEntries(entries) as unknown as IContactLensForm;
        payload.leftQuantity = '0';
    }

    // remove right eye data if not selected
    if (!payload.rxRightEye) {
        const entries = Object.entries(payload).filter(
            ([k, _]) => !k.toLowerCase().includes('right')
        );
        payload = Object.fromEntries(entries) as unknown as IContactLensForm;
        payload.rightQuantity = '0';
    }

    return payload;
};
